import { createI18n } from 'vue-i18n'
import tk from './locale/tk.json'
import ru from './locale/ru.json'

const i18n = createI18n({
    locale: 'tk',
    fallbackLocale: 'tk',
    legacy: false,
    messages: {
        tk, ru
    },

})
export { i18n }